/* Progressive enhancement: reads existing photos, never touches purchase/variant handlers. */
(() => {
  'use strict';
  const copy = {
    es: {title:'Imágenes del producto',close:'Cerrar imágenes',prev:'Imagen anterior',next:'Imagen siguiente',image:(n,t)=>`Imagen ${n} de ${t}`,open:(n,t)=>`Ampliar imagen ${n} de ${t}`},
    en: {title:'Product images',close:'Close images',prev:'Previous image',next:'Next image',image:(n,t)=>`Image ${n} of ${t}`,open:(n,t)=>`View image ${n} of ${t}`},
    fr: {title:'Images du produit',close:'Fermer les images',prev:'Image précédente',next:'Image suivante',image:(n,t)=>`Image ${n} sur ${t}`,open:(n,t)=>`Agrandir l’image ${n} sur ${t}`},
    de: {title:'Produktbilder',close:'Bilder schließen',prev:'Vorheriges Bild',next:'Nächstes Bild',image:(n,t)=>`Bild ${n} von ${t}`,open:(n,t)=>`Bild ${n} von ${t} vergrößern`},
    ru: {title:'Фотографии товара',close:'Закрыть фотографии',prev:'Предыдущее фото',next:'Следующее фото',image:(n,t)=>`Фото ${n} из ${t}`,open:(n,t)=>`Увеличить фото ${n} из ${t}`},
    zh: {title:'商品图片',close:'关闭图片',prev:'上一张图片',next:'下一张图片',image:(n,t)=>`第 ${n} 张，共 ${t} 张`,open:(n,t)=>`放大第 ${n} 张图片，共 ${t} 张`}
  };
  const svg = (path) => `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">${path}</svg>`;
  const icons = {open:svg('<circle cx="10" cy="10" r="6.5"/><path d="m15 15 6 6M7 10h6M10 7v6"/>'),close:svg('<path d="m6 6 12 12M18 6 6 18"/>'),prev:svg('<path d="m14 5-7 7 7 7"/>'),next:svg('<path d="m10 5 7 7-7 7"/>')};
  function fitPhoto(photo,frame) {
    let box=null,source='';
    const place=()=>{
      if(!photo.complete||!photo.naturalWidth||!frame.clientWidth||!frame.clientHeight) return;
      const url=photo.currentSrc||photo.src;
      if(url!==source){
        source=url;box=null;delete photo.dataset.ohPhotoFit;
        ['width','height','left','top'].forEach(key=>photo.style.removeProperty('--oh-photo-'+key));
        try {
          const canvas=document.createElement('canvas');canvas.width=360;canvas.height=Math.max(1,Math.round(360*photo.naturalHeight/photo.naturalWidth));
          const context=canvas.getContext('2d',{willReadFrequently:true});context.drawImage(photo,0,0,canvas.width,canvas.height);
          const pixels=context.getImageData(0,0,canvas.width,canvas.height).data;
          const corners=[0,(canvas.width-1)*4,(canvas.height-1)*canvas.width*4,(canvas.width*canvas.height-1)*4];
          if(!corners.every(p=>pixels[p+3]<20||Math.min(pixels[p],pixels[p+1],pixels[p+2])>235)) return;
          let left=canvas.width,top=canvas.height,right=0,bottom=0,count=0;
          for(let y=0;y<canvas.height;y++) for(let x=0;x<canvas.width;x++){
            const p=(y*canvas.width+x)*4;
            if(pixels[p+3]>24&&Math.min(pixels[p],pixels[p+1],pixels[p+2])<220){left=Math.min(left,x);right=Math.max(right,x);top=Math.min(top,y);bottom=Math.max(bottom,y);count++;}
          }
          if(count<60||right-left<canvas.width*.15||(right-left>canvas.width*.92&&bottom-top>canvas.height*.85)) return;
          const padding=Math.max(right-left,bottom-top)*.08;
          left=Math.max(0,left-padding);top=Math.max(0,top-padding);right=Math.min(canvas.width,right+padding);bottom=Math.min(canvas.height,bottom+padding);
          box={left:left/canvas.width,top:top/canvas.height,width:(right-left)/canvas.width,height:(bottom-top)/canvas.height};
        } catch(error) { return; }
      }
      if(!box) return;
      const scale=Math.min(frame.clientWidth/(photo.naturalWidth*box.width),frame.clientHeight/(photo.naturalHeight*box.height));
      const width=photo.naturalWidth*scale,height=photo.naturalHeight*scale;
      photo.dataset.ohPhotoFit='true';
      photo.style.setProperty('--oh-photo-width',width+'px');photo.style.setProperty('--oh-photo-height',height+'px');
      photo.style.setProperty('--oh-photo-left',((frame.clientWidth-width*box.width)/2-width*box.left)+'px');
      photo.style.setProperty('--oh-photo-top',((frame.clientHeight-height*box.height)/2-height*box.top)+'px');
    };
    photo.addEventListener('load',()=>{source='';place();});
    new ResizeObserver(place).observe(frame);place();
  }
  function init(scope=document) {
    if(!('HTMLDialogElement' in window)) return;
    const lang=(document.documentElement.lang||'es').toLowerCase().split('-')[0];
    const t=copy[lang]||copy.es;
    scope.querySelectorAll('.oh-th__gallery:not([data-oh-viewer-ready])').forEach(gallery => {
      const photos=[...gallery.querySelectorAll('.oh-th__gmain img,.oh-th__gcell img')];
      if(!photos.length) return;
      gallery.dataset.ohViewerReady='true';
      const root=gallery.closest('.shopify-section')||gallery.parentElement;
      const name=root.querySelector('h1')?.textContent.trim()||'';
      const dialog=document.createElement('dialog');
      dialog.className='oh-pdp-viewer';
      dialog.setAttribute('aria-label',t.title);
      const header=document.createElement('div');header.className='oh-pdp-viewer__header';
      const title=document.createElement('h2');title.className='oh-pdp-viewer__title';title.textContent=t.title;
      const control=(label,icon) => {const b=document.createElement('button');b.type='button';b.className='oh-pdp-viewer__control';b.setAttribute('aria-label',label);b.innerHTML=icon;return b;};
      const close=control(t.close,icons.close);close.autofocus=true;header.append(title,close);
      const figure=document.createElement('figure');figure.className='oh-pdp-viewer__figure';
      const image=document.createElement('img');image.className='oh-pdp-viewer__image';image.decoding='async';figure.append(image);
      const fit=gallery.dataset.ohPhotoFit==='true';if(fit) fitPhoto(image,figure);
      const footer=document.createElement('div');footer.className='oh-pdp-viewer__footer';
      const prev=control(t.prev,icons.prev),next=control(t.next,icons.next);
      prev.hidden=next.hidden=photos.length<2;
      const counter=document.createElement('p');counter.className='oh-pdp-viewer__counter';counter.setAttribute('aria-live','polite');counter.setAttribute('aria-atomic','true');
      footer.append(prev,counter,next);dialog.append(header,figure,footer);root.append(dialog);
      let index=0,opener=null;
      function show(n) {
        index=(n+photos.length)%photos.length;
        // Read the current source when opening: variant changes can replace the primary image.
        const source=new URL(photos[index].currentSrc||photos[index].src,document.baseURI);
        if((source.hostname===location.hostname&&source.pathname.startsWith('/cdn/shop/'))||source.hostname==='cdn.shopify.com'||(source.hostname==='opticalh.com'&&source.pathname.startsWith('/cdn/shop/'))) source.searchParams.set('width','1800');
        image.src=source.href;
        image.alt=`${name} — ${t.image(index+1,photos.length)}`;
        counter.textContent=t.image(index+1,photos.length);
      }
      const triggers=photos.map((photo,n)=>{
        const button=document.createElement('button');button.type='button';button.className='oh-pdp-image-trigger';button.setAttribute('aria-label',t.open(n+1,photos.length));button.setAttribute('aria-haspopup','dialog');
        photo.replaceWith(button);button.append(photo);
        const icon=document.createElement('span');icon.className='oh-pdp-image-trigger__icon';icon.setAttribute('aria-hidden','true');icon.innerHTML=icons.open;button.append(icon);
        if(fit) fitPhoto(photo,button);
        button.addEventListener('click',()=>{opener=button;show(n);dialog.showModal();});
        return button;
      });
      close.addEventListener('click',()=>dialog.close());
      prev.addEventListener('click',()=>show(index-1));next.addEventListener('click',()=>show(index+1));
      dialog.addEventListener('keydown',event=>{
        if(event.key==='Tab'){
          const controls=[close,prev,next].filter(button=>!button.hidden);
          const first=controls[0],last=controls[controls.length-1];
          if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
          else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
        }
        if(event.key==='ArrowLeft'){event.preventDefault();show(index-1);}
        if(event.key==='ArrowRight'){event.preventDefault();show(index+1);}
      });
      dialog.addEventListener('close',()=>{if(opener?.isConnected) opener.focus({preventScroll:true});});
      // Theme editor section replacement also removes its dialog; no global styles/listeners retained.
      gallery._ohViewer={dialog,triggers};
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
  else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
